export const ICON_BY_CODE = {
  REFUND: 'icon-refund',
  REGISTRATION_MISTAKE: 'icon-registration-mistake',
};
